import { AlertAction } from '@simplywallst/ui-core';
import { ErrorBoundary } from '@sentry/react';
import { Alert } from '@simplywallst/ui-core';
import { Suspense } from 'react';
import { NarrativeCardCompactSyntheticLoading } from './components/NarrativeCardCompactSyntheticLoading';
import { NarrativeCardCompactSyntheticMain } from './components/NarrativeCardCompactSyntheticMain';

type Props = {
  canonicalUrl: string;
  type: 'DCF' | 'ANALYSTS';
};

export const NarrativeCardCompactSynthetic = ({
  canonicalUrl,
  type,
}: Props) => {
  return (
    <ErrorBoundary
      fallback={
        <Alert
          styleType="negative"
          actions={
            <AlertAction onClick={() => window.location.reload()}>
              Reload
            </AlertAction>
          }
        >
          Failed to load narrative. Please try again.
        </Alert>
      }
    >
      <Suspense fallback={<NarrativeCardCompactSyntheticLoading />}>
        <NarrativeCardCompactSyntheticMain
          canonicalUrl={canonicalUrl}
          type={type}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
